import { render, staticRenderFns } from "./postRecord.vue?vue&type=template&id=6cba86e2&scoped=true"
import script from "./postRecord.vue?vue&type=script&lang=js"
export * from "./postRecord.vue?vue&type=script&lang=js"
import style0 from "./postRecord.vue?vue&type=style&index=0&id=6cba86e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba86e2",
  null
  
)

export default component.exports